import { ENDPOINTS } from "../config";

/**
 * Fetch the list of active languages from the Language Master.
 * Returns an array of language records ({ value, culture, englishName }),
 * or an empty array on failure.
 *
 * @returns {Promise<Array<{ value: string, culture: string, englishName: string }>>}
 */
export const getActiveLanguages = async () => {
    try {
        const response = await fetch(ENDPOINTS.LANGUAGES.PUBLIC);
        const data = await response.json();
        if (data?.isOk) {
            return data.data || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching languages:", error);
        return [];
    }
};

export default { getActiveLanguages };
